import { apiAxios } from '../../../helpers'

export const getList = async commit => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('acts/')
    .finally(_ => commit('updateLoading', false))
  commit('updateList', result.data.data.acts)
}
export const getSelectList = async ({ commit }, payload) => {
  const set = payload.set !== false
  delete payload.set

  commit('updateLoading', true)
  const result = await apiAxios
    .get('acts/select')
    .finally(_ => commit('updateLoading', false))
  if (set) commit('updateSelectList', result.data.data.acts || [])
  return result.data.data.acts || []
}

export const getOne = async (commit, id) => {
  commit('updateLoading', true)
  const result = await apiAxios
    .get('acts/' + id)
    .finally(_ => commit('updateLoading', false))
  commit('updateOne', result.data.data.act)
}

export const getOneByScore = async (commit, idScore) => {
  if (!idScore) return
  const result = await apiAxios.get('actsScores/' + idScore)
  commit('updateOne', result.data.data.act)
  await getCategories(commit, result.data.data.act._id)
  return result.data.data.act
}
export const getCategories = async (commit, actId) => {
  if (!actId) return
  const result = await apiAxios.get(`acts/${actId}/categories`)
  commit('updateCategories', result.data.data.categories)
}
export const getScoreResult = async (commit, matchId) => {
  const result = await apiAxios.get('actsScoresResults/' + matchId)
  commit('updateScoreResults', result.data.data.scoreResults)
  commit('updateJudgesScores', result.data.data.judgesScores)
}
